module.exports = "/lucky-balls/img/fast-arrow-down.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/fast-arrow-down.png
// module id = 231
// module chunks = 0